/**
 * Juicer Station Page
 * KDS display for juice bar to prepare drinks
 * Uses shared KDSStationLayout with auto-reconnect and offline caching
 */
import { GlassWater } from 'lucide-react';
import KDSStationLayout from '@/components/kds/KDSStationLayout';

export default function JuiceBarStationPage() {
  return (
    <KDSStationLayout
      station="juicer"
      stationName="Juice Bar Station"
      stationIcon={GlassWater}
      iconColorClass="bg-gradient-to-br from-green-500 to-green-600"
      defaultDeviceId="KDS-JCR-01"
    />
  );
}
